<template>
    <div class="col-md-8 col-sm-12 mb-5 margin-top-sm">
        <div id="wrapper-direct-access">
          <b-row v-if="isEmpty(userData)" style="color: red; font-size: 16px; margin: 0">
            <b><span>Eventuell fehlende Berechtigungen zur Nutzung der Konfigurators!</span></b>
          </b-row>
            <b-card-header header-tag="header" class="p-2 height-xs-sm" style="height: 38px" v-if="!isKunde && !isAnonym">
              <b-row>
                <b-col cols="6" class="rm-on-md-lg-xl-display">
                  <span>{{productBreadcrumb}}</span>
                </b-col>
                <b-col cols="6" md="12" class="my-auto">
                  <button class="btn direct-access-btn dropdown-toggle-no-caret defloat-on-sm-xs"
                          style="color: #337ab7"
                          v-b-toggle="'accordion'+ 1"
                          @click="removeCssFromElement(), initProductBreadcrumb(), resetProductListAndSizes(), changeProductTreeVisibility(false)">
                    <b-icon-caret-down-fill style="color: black" id="directAccessCaret" class="caret-transition" font-scale="0.80"/>
                    {{$t('direct-entry.title')}}
                  </button>
                </b-col>

          </b-row>
            </b-card-header>

        <b-collapse :id="'accordion'+ 1"
                    :visible="directAccessVisibility"
                    v-on:hidden="changeDirectAccessVisibility(false), addCssToClickedElement()"
                    v-on:shown="changeDirectAccessVisibility(true)">
            <div class="panel panel-default" v-if="isAnonym || isKunde" style="padding-top: 30px;"></div>
            <div class="panel panel-default" v-if="!isAnonym && !isKunde">
                <div class="panel-body border p-3 mb-2">
                  <div id="directAccessCompletely">
                    <div v-if="isUserModeStandard">
                        <fieldset>
                            <legend>{{$t('direct-entry.typeAndSize')}}</legend>
                            <div class="row">
                                <div class="col-sm-12 col-md-4">
                                    <b-form-group :label="$t('direct-entry.size')">
                                        <b-form-input v-model="size" id="articleSize" class="form-control rounded-0" @keyup.enter="searchBySizeAndType"/>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-12 col-md-4">
                                    <b-form-group :label="$t('direct-entry.type')">
                                        <b-form-input v-model="type"  id="articleType" class="form-control rounded-0"  @keyup.enter="searchBySizeAndType"/>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-3 col-md-4 my-auto" style="padding-top: 10px">
                                    <span class="" id="disabled-wrapper-tt">
                                        <b-button :class="[validateSizeAndType ? 'mayr-button-blue' : 'mayr-button-inactive', 'btn']" @click="searchBySizeAndType()" :disabled="!validateSizeAndType">{{$t('direct-entry.modifyArticle')}}</b-button>
                                    </span>
                                    <b-tooltip v-if="!validateSizeAndType" target="disabled-wrapper-tt">{{$t('direct-entry.configureSizeAndTypeBtnTooltip')}}</b-tooltip>
                                </div>
                            </div>
                        </fieldset>
                        <br/>
                    </div>
                  <div id="artNrDevCondition">
                    <legend>{{$t('direct-entry.byArticleNumber')}}</legend>
                    <div class="row">
                      <div class="col-sm-12 col-md-4">
                        <b-form-group :label="$t('direct-entry.articlenumber')">
                          <b-form-input v-model="teileNr" maxlength="7" id="articleNumber" class="rounded-0" required @keyup.enter="searchByPartNumber(false)"/>
                        </b-form-group>
                      </div>

                      <div class="col-sm-12 col-md-4">
                        <b-form-group :label="$t('direct-entry.deliverycondition')">
                          <b-form-input maxlength="3" v-model="lieferzustand" id="deliveryCondition" class="rounded-0" @keyup.enter="searchByPartNumber(false)"/>
                        </b-form-group>
                      </div>

                      <div class="col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2 my-auto" style="padding-top: 10px">
                                    <span id="disabled-wrapper-tooltip">
                                      <b-button :class="[validateArtNrAndLieferzustand ? 'mayr-button-blue' : 'mayr-button-inactive', 'btn']"
                                                @click="searchByPartNumber(true)"
                                                :disabled="!validateArtNrAndLieferzustand">
                                                {{$t('direct-entry.modifyArticle')}}
                                      </b-button>
                                    </span>
                        <b-tooltip v-if="!validateArtNrAndLieferzustand" target="disabled-wrapper-tooltip">{{$t('direct-entry.configureButtonTooltip')}}</b-tooltip>
                      </div>
                      <div class="col-12 col-sm-4 col-md-12 col-lg-11 col-xl-2 my-auto pt-zero" style="padding-top: 10px">
                                  <span id="disabled-wrapper" class="float-and-padding">
                                    <b-button :class="[validateArtNrAndLieferzustand ? 'mayr-button-blue' : 'mayr-button-inactive', 'btn']"
                                              @click="searchByPartNumber(false)"
                                              :disabled="!validateArtNrAndLieferzustand">
                                              {{ $t('direct-entry.start') }}
                                    </b-button>
                                  </span>
                        <b-tooltip v-if="!validateArtNrAndLieferzustand" target="disabled-wrapper">{{$t('direct-entry.startButtonTooltip')}}</b-tooltip>
                      </div>
                    </div>
                  </div>
                  </div>
                    <br/>
                </div>
            </div>
            <div class="row">
                <a class="pl-3">
                    <b style="color: #337ab7;">{{$t('start-page.hinweis')}}</b> <br>
                    {{$t('start-page.startseiteHinweisTextAnfang')}}
                    <b-icon icon="star" class="custom-icon-hinweistext" style="color: #007bff;"/>
                    {{$t('start-page.startseiteHinweisTextEnde')}}
                </a>

            </div>
        </b-collapse>
        </div>
<!--        <div class="row" v-if="isUserExtern && directAccessVisibility">-->
<!--            <a class="pl-3">-->
<!--                <b style="color: #337ab7;">{{$t('start-page.hinweis')}}</b> <br>-->
<!--                {{$t('start-page.startseiteHinweisTextAnfang')}}-->
<!--                <b-icon icon="star" class="custom-icon-hinweistext" style="color: #007bff;"/>-->
<!--                {{$t('start-page.startseiteHinweisTextEnde')}}-->
<!--            </a>-->

<!--        </div>-->
        <div class="row" v-if="!directAccessVisibility && productList != ''">
            <div class="col-sm-12 col-md-6 col-lg-4" :style="products.isLeaf ? '' : 'display: none'" v-for="products in productList" :key="products.id">
                <ProductList v-if="products.isLeaf" :products="products" :crumb="productBreadcrumb"/>
            </div>
        </div>
        <ProductSizes v-if="!directAccessVisibility && !this.isEmpty(productSizes.gruppen) && this.isEmpty(productList)"/>
        <MaxStklModal :maximalStuecklisten="maximalStuecklistenList"/>
    </div>
</template>

<script>
    import {router} from "@/main";
    import ProductList from "./ProductList";
    import ProductSizes from "./ProductSizes";
    import isEmpty from "@/mixins/isempty";
    import url from "@/rest/url";
    import { v1 as uuidv1 } from 'uuid';
    import MaxStklModal from "./MaxStklModal";
    import axios from 'axios';
    import i18n from "@/i18n/i18n";
    import matomoTracking from "@/mixins/matomoTracking";
    // import {isExtendedError} from "vue-router/src/util/warn";

    export default {
        name: "DirectAccess",
        components: {MaxStklModal, ProductSizes, ProductList},
        mixins: [isEmpty, matomoTracking],
        data: function () {
            return {
                isValidating: false,
                teileNr: '',
                lieferzustand: '0',
                size: '',
                type: '',
                maxStklId: '',
                maximalStuecklistenList: {},
            };
        },
        computed: {
            konfigModel: function () {
                return this.$store.getters.konfigModel;
            },
            productBreadcrumb: function () {
                return this.$store.getters.productBreadcrumb;
            },
            productList: function () {
                return this.$store.getters.productList;
            },
            userData: function() {
                return this.$store.getters.getUserData;
            },
            directAccessVisibility: function () {
                return this.$store.getters.directAccessVisibility;
            },
            productSizes: function () {
                return this.$store.getters.productSizes;
            },
            validateArtNrAndLieferzustand: function () {
                return this.teileNr.length === 7 && this.lieferzustand != ''
            },
            validateSizeAndType: function () {
                return this.size != '' && this.type != ''
            },
            isUserModeStandard: function () {
                if(this.userData.defaultModus === undefined){
                    return true
                    } else if (this.userData.defaultModus.includes('STANDARD')) {
                        return true
                        } else if(this.userData.defaultModus.includes('EXPERT')) {
                            return false
                }
                return true
            },
            isKunde: function () {
                return this.$store.getters.getUserData.kunde
            },
            isAnonym: function () {
              return this.$store.getters.getUserData.anonym
            },
            csrfToken: function () {
                return this.$store.getters.csrfToken
            }
        },
        created() {
            this.initProductBreadcrumb();
            this.trackPageView()
        },
        methods: {
          // isExtendedError,
            overviewByKonfigModel() {
              console.log('entered overview call')
                let loadingFlag = uuidv1();
                this.$store.commit('setLoadingFlag', loadingFlag)
                let data = JSON.stringify(this.konfigModel)
                axios.post(url.overviewURL+ 'JSON', data, {
                        headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': i18n.locale,
                        'X-CSRF-TOKEN': this.csrfToken['X-CSRF-TOKEN']
                        },
                    }).then(response => {
                        if(response.status == 200){
                                window.location.href = url.apiLocation + '/overview'
                        }
                    })
                    .catch(error => {
                     console.log(error)
                     this.$notify({
                         type: 'error', duration: 3000,
                         text: this.$t('error-messages.configureNotPossible')
                      });
                    })
                    .finally(() => {
                        this.$store.commit('removeLoadingFlag', loadingFlag);
                    });
            },
            searchByPartNumber(toConfigure) {
                if(this.teileNr.length === 7 && this.lieferzustand != '' ) {
                    this.$store.commit('setKonfigModel', {})
                    let loadingFlag = uuidv1();
                    this.$store.commit('setLoadingFlag', loadingFlag);
                    this.$store.dispatch('initModelByArticleNo',
                        {
                            articleNumber: this.teileNr,
                            deliveryCondition: this.lieferzustand,
                            toConfigure: toConfigure
                        })
                        .then( (response) => {
                            if(response.errors.length > 0){
                                this.$notify({
                                  type: 'error', duration: 3000,
                                  text: this.$t(response.errors[0])
                                });
                            } else if (toConfigure && !response.specialOverview && this.isUserModeStandard){
                              //StandardModus, normales Teil => Vue Konfigurationsseite
                                router.push({
                                    name: 'ConfigPageByArticleNo',
                                    params: {
                                        articleNumber: this.teileNr,
                                        deliveryCondition: this.lieferzustand
                                    }
                                })
                            } else if (!toConfigure  && !response.specialOverview && response.isTeilSonder){
                                 //Uebersicht ohne KonfigModel, weil Sonderteil keins hat
                                 window.location.href = url.apiLocation + '/overview'
                            } else if (!toConfigure  && !response.specialOverview ){
                              //Normales Teil hat KonfigModel
                              this.overviewByKonfigModel(loadingFlag)
                            }
                            else if(response.specialOverview && this.isUserModeStandard){
                              //StandardModus und Sonderteil => besondere Uebersicht
                                window.location.href = url.apiLocation + '/specialOverview?articleNumber=' + this.teileNr
                                    + '&deliveryCondition=' + this.lieferzustand
                            } else if (toConfigure && !this.isUserModeStandard){
                              //Konfigurieren als Experte => besondere Konfigurationsseite
                                window.location.href = url.apiLocation + '/expert/article/' +this.teileNr + '/' + this.lieferzustand;
                            }
                        }).finally(() => {
                        this.$store.commit('removeLoadingFlag', loadingFlag);
                    })
                } else {
                        if(this.teileNr.length != 7){
                            this.$notify({
                                type: 'error', duration: 3000,
                                text: this.$t('error-messages.keineArtikelNr')
                            });
                        }
                        if(this.lieferzustand == ''){
                            this.$notify({
                                type: 'error', duration: 3000,
                                text: this.$t('error-messages.keinLieferzustand')
                            });
                        }

                    }

            },
            searchBySizeAndType() {
                if(this.size != '' && this.type != ''){
                    this.$store.commit('setKonfigModel', {})
                    this.$store.dispatch('initModelBySizeType', {
                        type: this.type,
                        size: this.size
                    }).then( (response) => {
                        if(response.errors.length > 0){
                            this.$notify({
                                type: 'error', duration: 3000,
                                text: this.$t(response.errors[0])
                            });
                        } else if (response.konfigModel.i18nBenennung == null && response.konfigModel.stuecklistenInfos.length > 0){
                            //Wenn die Nummer nicht eindeutig ist, kommen mehrere Maxstkls zurück => Modal zur Auswahl öffnet sich
                            this.maximalStuecklistenList = response.konfigModel.stuecklistenInfos
                            this.$bvModal.show('maxStklModal')
                        } else {
                            router.push({
                                name: 'ConfigPageBySizeType',
                                params: {
                                    maxStklId: response.konfigModel.maxStuckelistenId,
                                    size: this.size,
                                    type: this.type
                                }
                            })
                        }
                    })
                } else {
                    if(this.size == ''){
                        this.$notify({
                            type: 'error', duration: 3000,
                            text: this.$t('error-messages.keineGroesse')
                        });
                    }
                    if(this.type == ''){
                        this.$notify({
                            type: 'error', duration: 3000,
                            text: this.$t('error-messages.keineType')
                        });
                    }

                }

            },
            initProductBreadcrumb() {
                this.$store.dispatch('setProductBreadcrumb', '');
            },
            resetProductListAndSizes() {
                this.$store.dispatch('setProductList', {})
                this.$store.dispatch('setProductSizes', {})
            },
            changeDirectAccessVisibility(visible) {
                this.$store.dispatch('setDirectAccessVisibility', visible);
            },
            changeProductTreeVisibility(visible){
                this.$store.dispatch('setProductTreeVisibility', visible);
            },
            addCssToClickedElement(){
              if(document.getElementById('directAccessCaret') != undefined && document.getElementById('directAccessCaret') != null){
                let caret = document.getElementById('directAccessCaret');
                caret.classList.add('rotate-caret');
              }
            },
            removeCssFromElement(){
                let caret = document.getElementById('directAccessCaret');
                caret.classList.remove('rotate-caret');
            },
        },
    }
</script>

<style scoped>
    .direct-access-btn {
        float: right;
        font-size: 14px;
        margin-top: -8px;
        margin-right: -4px;
    }
    legend {
        border-bottom: 1px solid black;
        padding: 2px 0px;
        width: 100%;
    }
    .custom-icon-hinweistext {
        color: #000000;
        margin: 2px 2px 0px;
        vertical-align: top;
        width: 15px;
        height: 15px;
    }

    .rotate-caret {
      transform: rotate(-90deg);
    }

    .caret-transition {
      margin-bottom: 3px;
      transition: transform 250ms;
    }

</style>